import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BorderTop, Height, Padding } from '@mui/icons-material';
import OriginService from '../../services/OriginService/OriginService';

// Define component styling
const useStyles = makeStyles((theme) => ({

    alertOverlay: {
        width: "100vw",
        height: "100vh",
        position: "fixed",
        background: "#18171775",
        zIndex: 99999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left:0,
        backdropFilter: "blur(1px)",
        WebkitBackdropFilter: "blur(5px)",
    },

    mainGrid: {
        border: "1px solid white",
        padding: "15px",
        borderRadius: "10px",
        color: "#79232e",
        background: "#ffffff",
        width: "36%",
        height: "fit-content ",
        display:"flex",
        flexDirection: "column",
        justifyContent: "space-between",

    },
    innerGridheading:{
        marginBottom: " 10px",
        borderBottom: "1px solid #79232e",
    },
    innerGridtext:{
        marginBottom: " 10px",
        display: "flex",
        flexDirection: "column",
        color: "#000",
        fontWeight: "bold",
            },
    buttonMain: {
        display: "flex",
        justifyContent: "end",
        gap: ".5rem",
        borderTop: "1px solid #79232e",
        paddingTop: "8px",
    },

    button: {
    background: "#79232e",
    width: "104px",
    color: "white",
    borderRadius: "50px",
    fontSize: "12px",
    transition: "0.3s",
    textTransform: 'capitalize',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&:active': {
      color: '#fff',
      backgroundColor: '#79232e'
    },
    '&:focus': {
      color: '#fff',
      backgroundColor: '#79232e'
    }
    },
   

}));




const renderRequiredError = (error) => {
    if (!error) return null;

    return (
        <span style={{ marginRight: '8px' }}>
            {error}
            <span style={{ color: 'red', fontWeight: 'bold' }}> *</span>
        </span>
    );
};
/*
this page showing login error message on the UI
*/
const RequiredFieldAlert = (props) => {

    const classes = useStyles();
    const host = props.host;
    const handleClose = async () => {
        const proxy = await host;
        const close = await proxy.close();

        return close;
    };

   

    return (
        <>


                <Box className={classes.alertOverlay}>
                    <Grid className={classes.mainGrid}>
                        <Grid>
                            <Typography variant="h5" component="div" className={classes.innerGridheading}>
                               Required Fileds
                            </Typography>
                            <Typography variant="p" component="div" className={classes.innerGridtext}>
                            {renderRequiredError(props.requiredfielderrors?.loanNumber)}
                            {renderRequiredError(props.requiredfielderrors?.verificationType)}
                            {renderRequiredError(props.requiredfielderrors?.provider)}
                            {renderRequiredError(props.requiredfielderrors?.product)}
                            {renderRequiredError(props.requiredfielderrors?.loanPurposeType)}

                            </Typography>
                        </Grid>
                        <Box component="span" className={classes.buttonMain}>
                          
                            <Button variant="contained" className={`${classes.button}`} onClick={handleClose}>
                            {"Close"}
                            </Button>
                        </Box>
                    </Grid>
                </Box>




        </>

    )
};

export default RequiredFieldAlert;
